// Globals
import React from 'react';
import { useTranslation } from 'react-i18next';

// Models
import { UserStatus, IUser } from '@/models/users.model';

// Components
import { StyledActionsWrap } from './UserStatusChangeStyles';
import { StyledActionButton, StyledActivationButton } from '../Styled';
import { getEntityId } from '@/utils';

type TUserTableActions = {
  user: IUser;
  updateUserStatus: (id: string, status: UserStatus) => void;
};

const UserStatusChange = ({ user, updateUserStatus }: TUserTableActions) => {
  const { t } = useTranslation(['users']);
  const id = getEntityId(user?.PK);
  const isActive = user.status === UserStatus.ACTIVE;

  const onStatusUpdate = (e: React.MouseEvent<HTMLButtonElement>) => {
    e.stopPropagation();
    const newStatus = isActive ? UserStatus.DEACTIVATED : UserStatus.ACTIVE;
    updateUserStatus(id, newStatus);
  };

  return (
    <StyledActionsWrap>
      {isActive ? (
        <StyledActionButton type={'default'} onClick={onStatusUpdate}>
          {t('user_actions_deactivate')}
        </StyledActionButton>
      ) : (
        <StyledActivationButton type={'link'} onClick={onStatusUpdate}>
          {t('user_actions_activate')}
        </StyledActivationButton>
      )}
    </StyledActionsWrap>
  );
};

export default UserStatusChange;
